
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/attorney",
      function () {
        return require("private-next-pages/attorney.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/attorney"])
      });
    }
  